module.exports = __webpack_public_path__ + "static/media/back.8319dff4.svg";